import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const CheckboxCheckIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} viewboxSize="sm">
    <path d="M12.207 4.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414L7 8.586l3.793-3.793a1 1 0 0 1 1.414 0Z" />
  </BaseIcon>
);
